function withRedirectQueryParam(url) {
  const urlHasQueryParams = url.indexOf('?') > -1;

  return urlHasQueryParams ? `${url}&redirect=1` : `${url}?redirect=1`;
}

if (!customElements.get('geolocation-modal')) {
  customElements.define(
    'geolocation-modal',
    class GeolocationModal extends HTMLElement {
      constructor() {
        super();

        this.options = this.querySelectorAll('.geolocation__option a');
        this.options.forEach((option) => {
          option.addEventListener('click', this.onContinue.bind(this));
        });

        this.popup = this.parentElement;
        this.popup.addEventListener('click', (event) => {
          if (event.target === this.popup) {
            this.forceRedirect();
          }
        });

        this.querySelector('[id^="ModalClose-"]').addEventListener('click', () => {
          this.forceRedirect();
        });

        this.init();
      }

      init() {
        // Skip geolocation redirect entirely when running on a local dev server
        // (Shopify CLI `theme dev` serves on localhost/127.0.0.1).
        const isLocalDev = ['localhost', '127.0.0.1'].includes(window.location.hostname);
        if (isLocalDev) {
          return;
        }

        // Check if you were sent here automatically, if yes, don't redirect again.
        const urlParams = new URLSearchParams(window.location.search);
        const userWasRedirectedHere = Boolean(urlParams.get('redirect'));
        if (userWasRedirectedHere) {
          localStorage.setItem('GLDisplayed', true);
          localStorage.setItem('GLPreferred', window.location.origin);

          return;
        }

        const isLinksSubdomain = window.location.host == 'links.reigningchamp.com';
        if (isLinksSubdomain) {
          window.location.href = 'https://linktr.ee/reigningchamp';

          return;
        }

        const userPreferredOrigin = localStorage.getItem('GLPreferred');
        const userHasPreferredOrigin = Boolean(userPreferredOrigin);
        if (userHasPreferredOrigin) {
          const userIsOnPreferredOrigin = userPreferredOrigin == window.location.origin;
          if (!userIsOnPreferredOrigin) {
            window.location.href = userPreferredOrigin + window.location.pathname + '?redirect=1';
          }

          return;
        }

        const userHasSeenGeolocationBanner =
          localStorage.getItem('GLDisplayed') == 'true' || sessionStorage.getItem('GLDisplayed') == 'true';
        if (!userHasSeenGeolocationBanner) {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
            if (error) {
              console.error('[ Geolocation ] :: Shopify Customer Privacy API failed to load...', { error });

              return;
            }

            const region = window.Shopify.customerPrivacy.getRegion() || '';
            const countryCode = region.slice(0, 2);

            const userIsNonCanadianOnCanadianStore = window.country == 'ca' && countryCode != 'CA';
            const userIsCanadianOnUsaStore = window.country == 'usa' && countryCode == 'CA';

            if (userIsNonCanadianOnCanadianStore || userIsCanadianOnUsaStore) {
              this.show();
            }
          });
        }

        sessionStorage.setItem('GLDisplayed', true);
      }

      show() {
        this.parentElement.show();
      }

      hide() {
        this.parentElement.hide();
      }

      forceRedirect() {
        this.options.forEach((option) => {
          const userSelectedThisOption = option.classList.contains('active');
          if (!userSelectedThisOption) {
            return;
          }

          let location = option.dataset.location;

          localStorage.setItem('GLDisplayed', true);
          localStorage.setItem('GLPreferred', location);

          const userIsAlreadyOnLocation = window.location.href.indexOf(location) > -1;
          if (userIsAlreadyOnLocation) {
            return;
          }

          location += window.location.pathname;
          window.location.href = withRedirectQueryParam(location);
        });
      }

      onContinue(e) {
        e.preventDefault();

        let location = e.target.closest('.link').dataset.location;

        localStorage.setItem('GLDisplayed', true);
        localStorage.setItem('GLPreferred', location);

        const userIsAlreadyOnLocation = window.location.href.indexOf(location) > -1;
        if (userIsAlreadyOnLocation) {
          this.hide();

          return;
        }

        location += window.location.pathname;
        window.location.href = withRedirectQueryParam(location);
      }
    }
  );
}

if (!customElements.get('geolocation-change')) {
  customElements.define(
    'geolocation-change',
    class GeolocationChange extends HTMLElement {
      constructor() {
        super();

        this.close = this.querySelector('.geolocation__cancel');
        this.close.addEventListener('click', this.hide.bind(this));

        this.continue = this.querySelector('.geolocation__continue');
        this.continue.addEventListener('click', this.onContinue.bind(this));
      }

      onContinue() {
        const userPreferredLocale = this.getAttribute('data-locale');
        const userIsOnAccountPage = window.location.pathname == '/account';

        localStorage.setItem('GLDisplayed', true);
        localStorage.setItem('GLPreferred', userPreferredLocale);

        let url = userPreferredLocale + (userIsOnAccountPage ? '/account/login' : window.location.pathname);
        window.location.href = withRedirectQueryParam(url);
      }

      show() {
        this.parentElement.show();
      }

      hide() {
        this.parentElement.hide();
      }
    }
  );
}
